import React from "react";
import chefImage from "../../assets/Chef.png"; 

const styles = {
  container: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    fontFamily: "Arial, sans-serif",
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "20px",
  },
  imageSection: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  chefImage: {
    width: "100%",
    maxWidth: "500px",
    height: "auto",
    display: "block",
  },
  testimonialSection: {
    backgroundColor: "#fff",
    padding: "40px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  subtitle: {
    color: "#ff9933",
    fontWeight: "bold",
    fontSize: "14px",
  },
  title: {
    fontSize: "36px",
    fontWeight: "bold",
    lineHeight: "1.2",
    marginTop: "5px",
  },
  testimonialText: {
    fontSize: "18px",
    lineHeight: "1.6",
    color: "#555",
    fontStyle: "italic",
  },
  testimonialAuthor: {
    display: "flex",
    alignItems: "center",
    marginTop: "20px",
  },
  authorImage: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    objectFit: "cover",
    marginRight: "15px",
  },
  authorDetails: {
    flexGrow: 1,
  },
  authorName: {
    fontWeight: "bold",
    fontSize: "16px",
    margin: 0,
  },
  authorRole: {
    fontSize: "14px",
    color: "#888",
    margin: 0,
  },
  navigationArrows: {
    display: "flex",
    gap: "10px",
  },
  arrowButton: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    border: "1px solid #ccc",
    backgroundColor: "#fff",
    cursor: "pointer",
    fontSize: "20px",
    color: "#555",
  },
  rightArrow: {
    backgroundColor: "#ff9933",
    color: "#fff",
    border: "none",
  },
  rating: {
    marginTop: "15px",
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  star: {
    color: "gold",
    fontSize: "20px",
  },
};

const WhatSay = () => {
  return (
    <section style={styles.container}>
      <div style={styles.imageSection}>
        <img
          src={chefImage}
          alt="A smiling chef holding a plate of food"
          style={styles.chefImage}
        />
      </div>
      <div style={styles.testimonialSection}>
        <div className="testimonial-header">
          <p style={styles.subtitle}>WHAT THEY SAY</p>
          <h2 style={styles.title}>What Our Customers Say <br />About Us</h2>
        </div>
        <div>
          <p style={styles.testimonialText}>
            "Fudo is the best. Besides the many and delicious meals, the service
            is also very good, especially in the very fast delivery. I highly
            recommend Fudo to you".
          </p>
          <div style={styles.testimonialAuthor}>
            <img
              src={chefImage} 
              alt="Theresa Jordan"
              style={styles.authorImage}
            />
            <div style={styles.authorDetails}>
              <p style={styles.authorName}>Theresa Jordan</p>
              <p style={styles.authorRole}>Food Enthusiast</p>
            </div>
            <div style={styles.navigationArrows}>
              <button style={styles.arrowButton}>&lt;</button>
              <button style={{ ...styles.arrowButton, ...styles.rightArrow }}>
                &gt;
              </button>
            </div>
          </div>
          <div style={styles.rating}>
            <span style={styles.star}>&#9733;</span>
            <span style={styles.star}>&#9733;</span>
            <span style={styles.star}>&#9733;</span>
            <span style={styles.star}>&#9733;</span>
            <span style={styles.star}>&#9733;</span>
            <span>4.8</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatSay;